import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncognito = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.93747 8.99878L6.65877 4.66797C6.81984 3.70357 7.65519 2.99628 8.63259 2.99628H15.2463C16.2248 2.99628 17.0591 3.70357 17.2202 4.66797L17.9425 8.99878M10.2253 18.0025C10.2253 19.6601 8.88155 21.0038 7.22401 21.0038C5.56646 21.0038 4.22276 19.6601 4.22276 18.0025C4.22276 16.345 5.56646 15.0013 7.22401 15.0013C8.88155 15.0013 10.2253 16.345 10.2253 18.0025ZM10.2253 18.0025C11.1727 16.8591 12.7083 16.8591 13.6557 18.0025M13.6557 18.0025C13.6557 19.6601 14.9994 21.0038 16.6569 21.0038C18.3145 21.0038 19.6582 19.6601 19.6582 18.0025C19.6582 16.345 18.3145 15.0013 16.6569 15.0013C14.9994 15.0013 13.6557 16.345 13.6557 18.0025ZM2.99625 13.0004C7.96932 10.3323 16.0307 10.3323 21.0037 13.0004",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgIncognito);
export default ForwardRef;
